/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

const BaseGroupingRule = require('./base');

const GROUPS = ['control', // Treatment branches
'google']; // For each client specify which experiment group to show

const ROLLOUT_CONFIG = {
  // 123Done
  dcdb5ae7add825d2: GROUPS,
  // Pocket
  '7377719276ad44ee': GROUPS,
  '749818d3f2e7857f': GROUPS
}; // This experiment is disabled by default. If you would like to go through
// the flow, load email-first screen and append query params
// `?forceExperiment=thirdPartyAuth&forceExperimentGroup=google`

const ROLLOUT_RATE = 0.0;

module.exports = /*#__PURE__*/function (_BaseGroupingRule) {
  _inherits(ThirdPartyAuth, _BaseGroupingRule);

  var _super = _createSuper(ThirdPartyAuth);

  function ThirdPartyAuth() {
    var _this;

    _classCallCheck(this, ThirdPartyAuth);

    _this = _super.call(this);
    _this.name = 'thirdPartyAuth'; // Easier to set class properties for testability

    _this.groups = GROUPS;
    _this.rolloutRate = ROLLOUT_RATE;
    _this.rolloutConfig = ROLLOUT_CONFIG;
    return _this;
  }
  /**
   * For this experiment, we are doing a staged rollout.
   *
   * @param {Object} subject data used to decide
   *  @param {String} clientId clientId
   * @returns {Any}
   */


  _createClass(ThirdPartyAuth, [{
    key: "choose",
    value: function choose() {
      let subject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let choice = false;
      const clientId = subject.clientId;

      if (!clientId) {
        return;
      }

      const clientConfig = this.rolloutConfig[clientId];

      if (!clientConfig) {
        return;
      }

      if (this.bernoulliTrial(this.rolloutRate, subject.uniqueUserId)) {
        choice = this.uniformChoice(clientConfig, subject.uniqueUserId);
      }

      return choice;
    }
  }]);

  return ThirdPartyAuth;
}(BaseGroupingRule);